module.exports = __webpack_public_path__ + "img/10.b25f1c89.svg";